import React, { Component } from 'react'
import {
    setConformationPage,
    setAdminPage,
    roomSelectorStatus
} from '../../action/action'
import { connect } from 'react-redux'
import { conformationColorSet } from '../../JS/setColors'

class ConformationPage extends Component {
    onYesClick = () => {
        this.props.setConformationPage(false);
        this.props.setAdminPage(false);
        this.props.roomSelectorStatus(false);
    }
    onNoClick = () => {
        this.props.setConformationPage(false);
    }
    componentDidMount() {
        conformationColorSet(this.props.menuColor);
    }
    render() {
        return (
            <div className="overlay">
                <div id="svc" className="overlay-body">
                    <div className="primary-response center" style={{ color: "inherit" }}>
                        <div className="wide" style={{ fontSize: '20px', color: "inherit" }}>
                            {this.props.stringConst.regestrationConform}
                        </div>
                        <button className="btn-yes" onClick={() => { this.onYesClick() }} style={{ border: "none" }}>
                            {this.props.stringConst.yes}
                        </button>
                        <button className="btn-no" onClick={() => { this.onNoClick() }} style={{ border: "none" }}>
                            {this.props.stringConst.no}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        menuColor: state.store.home.MenuColor
    }
}
export default connect(
    mapStateToProps,
    {
        setConformationPage,
        setAdminPage,
        roomSelectorStatus
    }
)(ConformationPage);